import React from 'react';
import styled from 'styled-components';
import { ICourseInBlockPreviewProps } from './ICourseInBlockPreviewProps';
import { ReactComponent as ImageIcon } from 'containers/Library/Community/Courses/icons/image.svg';
import { isValidHexColor } from 'components/PageBuilder/PageBuilderSideBar/BlockSettings/domain';
import miscUtils from 'utils/miscUtils';
import { ButtonAction, scrollElementIntoView, ShadowPosition } from 'containers/PageBuilder/SinglePageContainer/domain';

const CourseContainer: any = styled.div<{design: any}>`
	flex: 0 1 calc((100% - 40px) / 3);
	border-radius: ${(props: any) => 
		props.design.course_container_border_radius ?
		`${props.design.course_container_border_radius}px` :
		`.5rem`
	};
	overflow: hidden;
	cursor: pointer;
	border-width: ${(props: any) => 
		props.design.course_container_border_width ?
		`${props.design.course_container_border_width}px` :
		`1px`
	};
	border-style: solid;
	border-color: ${(props: any) =>
		props.design.course_container_border_color &&
		isValidHexColor(props.design.course_container_border_color) ?
		props.design.course_container_border_color :
		'#D5D8DF'
	};
	background-color: ${(props: any) => 
		props.design.course_container_background_color &&
		isValidHexColor(props.design.course_container_background_color) ?
		props.design.course_container_background_color :
		'#FFFFFF'
	};
	box-shadow: ${(props: any) => 
		props.design.course_container_shadow_color &&
		isValidHexColor(props.design.course_container_shadow_color) ?
		props.design.course_container_shadow_position === ShadowPosition.Even ?
		`0px 0px 8px rgba(${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.b}, ${props.design.course_container_shadow_opacity ? props.design.course_container_shadow_opacity : 0.0})` :
		props.design.course_container_shadow_position === ShadowPosition.Bottom ?
		`0px 4px 8px rgba(${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.b}, ${props.design.course_container_shadow_opacity ? props.design.course_container_shadow_opacity : 0.0})` :
		props.design.course_container_shadow_position === ShadowPosition.Top ?
		`0px -4px 8px rgba(${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.b}, ${props.design.course_container_shadow_opacity ? props.design.course_container_shadow_opacity : 0.0})` :
		props.design.course_container_shadow_position === ShadowPosition.BottomRight ?
		`2px 4px 8px rgba(${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.b}, ${props.design.course_container_shadow_opacity ? props.design.course_container_shadow_opacity : 0.0})` :
		props.design.course_container_shadow_position === ShadowPosition.BottomLeft ?
		`-2px 4px 8px rgba(${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.b}, ${props.design.course_container_shadow_opacity ? props.design.course_container_shadow_opacity : 0.0})` :
		props.design.course_container_shadow_position === ShadowPosition.TopRight ?
		`2px -4px 8px rgba(${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.b}, ${props.design.course_container_shadow_opacity ? props.design.course_container_shadow_opacity : 0.0})` :
		props.design.course_container_shadow_position === ShadowPosition.TopLeft ?
		`-2px -4px 8px rgba(${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.course_container_shadow_color)!.b}, ${props.design.course_container_shadow_opacity ? props.design.course_container_shadow_opacity : 0.0})` :
		'none'
		:
		'none'
	};

	&.mobile {
		flex: 0 0 100%;
	}

	@media(max-width: 768px) {
		flex: 0 0 100%;
	}
`;

const CourseImageContainer: any = styled.div`
	width: 100%;
	height: auto;
	aspect-ratio: 200 / 148;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #D5D8DF;

	transition: .5s;
	
	&:hover {
		opacity: .8;
	}
`;

const CourseImage: any = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
`;

const CourseContentContainer: any = styled.div`
	padding: 20px;
`;

const CourseTitle: any = styled.p<{design: any}>`
	margin: 0;
	padding: 0;
	font-size: ${(props: any) =>
		props.design.course_name_p_font_size &&
		props.design.course_name_p_font_size <= 50 ?
		`${props.design.course_name_p_font_size}px` :
		`18px`
	};
	line-height: ${(props: any) =>
		props.design.course_name_p_line_height &&
		props.design.course_name_p_line_height <= 50 ?
		`${props.design.course_name_p_line_height}px` :
		`22px`
	};
	font-family: ${(props: any) =>
		props.design.course_name_p_font_family ?
		`${props.design.course_name_p_font_family} !important` :
		`-apple-system, Arial !important`
	};
	color: ${(props: any) => 
		props.design.course_name_p_color &&
		isValidHexColor(props.design.course_name_p_color) ?
		props.design.course_name_p_color :
		'#000000'
	};
	font-weight: bold;
	transition: .5s;

	&:hover {
		color: ${(props: any) => 
			props.design.course_name_color_hover &&
			isValidHexColor(props.design.course_name_color_hover) ?
			props.design.course_name_color_hover  :
			'#365DE6'
		};
	}
`;

const CourseInBlockPreview: React.FC<ICourseInBlockPreviewProps> = (props) => {

	const ctaOnClick = () => {
		if(props.buildingPreview) {
			return;
		}

		if(
			props.course &&
			props.course.redirect_action === ButtonAction.Default
		) {
				window.open(
				`${miscUtils.getRedirectBaseUrl(props.group)}/courses/${props.course.original_item.slug ? props.course.original_item.slug : props.course.original_item.id}`, 
				'_self'
				);
				return;
		}
		
		if(
			props.course &&
			(
				props.course.redirect_action === ButtonAction.URL ||
				props.course.redirect_action === ButtonAction.URLTab
			) &&
			props.course.redirect_url
		) {
			window.open(
				miscUtils.ensureHttps(props.course.redirect_url),
				props.course.redirect_action === ButtonAction.URLTab ?
				'_blank' :
				'_self'
			);
			return;
		}

		if(
			props.course &&
			props.course.redirect_action === ButtonAction.Scroll &&
			props.course.redirect_url &&
			props.containerBaseIdName
		) {
			scrollElementIntoView(`${props.containerBaseIdName}${props.course.redirect_url}`);
			return;
		}

		if(
			props.course &&
			props.course.redirect_action === ButtonAction.Popup &&
			props.course.redirect_url
		) {
			let nextPageFormsOpenState = JSON.parse(JSON.stringify(props.pageFormsOpenState));

			nextPageFormsOpenState[props.course.redirect_url] = true;

			props.setPageFormsOpenState(nextPageFormsOpenState);
			return;
		}

		if(
			props.course &&
			props.course.redirect_action === ButtonAction.Page &&
			props.course.redirect_url
		) {
			window.open(
				`${props.course.redirect_url}`, 
				'_self'
			);
			return;
		}
	}

	if(!props.course.original_item) {
		return <></>
	}

  return (
         <CourseContainer
        className={`${props.view ? props.view : ''}`}
		design={props.design}
        onClick={() => ctaOnClick()}
        >
          <CourseImageContainer
          >
            {props.course.original_item.thumbnail_image ? (
              <CourseImage
              src={props.course.original_item.thumbnail_image}
              />
            ) : (
              <ImageIcon
              />
            )}
          </CourseImageContainer>

          <CourseContentContainer
          >
            <CourseTitle
			design={props.design}
            >
              {props.course.original_item.title}
            </CourseTitle>
          </CourseContentContainer>
        </CourseContainer>
  )
}

export default CourseInBlockPreview;